import { render, staticRenderFns } from "./CardButtonGroup.vue?vue&type=template&id=b6d37d50&scoped=true&"
import script from "./CardButtonGroup.vue?vue&type=script&lang=js&"
export * from "./CardButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./CardButtonGroup.vue?vue&type=style&index=0&id=b6d37d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d37d50",
  null
  
)

export default component.exports